export const SUPABASE_URL_STORAGE_KEY = "memory-universe.supabase-url";
export const SUPABASE_KEY_STORAGE_KEY = "memory-universe.supabase-publishable-key";

export interface BrowserSupabaseConfig {
  url: string;
  publishableKey: string;
}

function readStoredValue(key: string) {
  if (typeof window === "undefined") return "";
  try {
    return window.localStorage.getItem(key)?.trim() ?? "";
  } catch {
    return "";
  }
}

export function getBrowserSupabaseConfig(): BrowserSupabaseConfig {
  return {
    url: readStoredValue(SUPABASE_URL_STORAGE_KEY) || import.meta.env.VITE_SUPABASE_URL?.trim() || "",
    publishableKey:
      readStoredValue(SUPABASE_KEY_STORAGE_KEY) || import.meta.env.VITE_SUPABASE_ANON_KEY?.trim() || ""
  };
}

export function validateBrowserSupabaseConfig(config: BrowserSupabaseConfig) {
  let parsedUrl: URL;
  try {
    parsedUrl = new URL(config.url.trim());
  } catch {
    return "Project URL 格式不正确";
  }

  if (parsedUrl.protocol !== "https:" || !parsedUrl.hostname.endsWith(".supabase.co")) {
    return "请输入 Supabase 提供的 https://…supabase.co 项目地址";
  }

  const key = config.publishableKey.trim();
  if (!key) return "请填写 Publishable key 或 anon public key";
  if (/service[_-]?role|secret/i.test(key)) return "这里不能填写 service_role 或 secret key";
  if (!key.startsWith("sb_publishable_") && key.split(".").length !== 3) {
    return "API Key 格式不正确，请复制 Publishable key 或 anon public key";
  }

  return null;
}

export function saveBrowserSupabaseConfig(config: BrowserSupabaseConfig) {
  window.localStorage.setItem(SUPABASE_URL_STORAGE_KEY, config.url.trim().replace(/\/$/, ""));
  window.localStorage.setItem(SUPABASE_KEY_STORAGE_KEY, config.publishableKey.trim());
}

export function clearBrowserSupabaseConfig() {
  window.localStorage.removeItem(SUPABASE_URL_STORAGE_KEY);
  window.localStorage.removeItem(SUPABASE_KEY_STORAGE_KEY);
}
